/**
 * 座位图分区排列方向枚举
 *
 * VERTICAL   - 上下排列（默认）：分区按 sortOrder 从上往下堆叠（offsetY 累加）
 * HORIZONTAL - 左右排列：分区按 sortOrder 从左往右排布（offsetX 累加）
 */
export enum SeatZoneLayout {
  /** 上下排列（默认） */
  VERTICAL = 'VERTICAL',
  /** 左右排列 */
  HORIZONTAL = 'HORIZONTAL',
}

/** 所有排列方向值的数组 */
export const SeatZoneLayoutValues: string[] = Object.values(SeatZoneLayout);

/** 排列方向中文标签映射 */
export const SeatZoneLayoutLabels: Record<SeatZoneLayout, string> = {
  [SeatZoneLayout.VERTICAL]: '上下排列',
  [SeatZoneLayout.HORIZONTAL]: '左右排列',
};
